module.exports = __webpack_public_path__ + "img/900f.39fda64a.png";